import { ButtonBaseProps } from "@mui/material"
import { Font, STEPS_EN } from "components/shopFeatures/wizard/constants"
import ButtonBaseBlank from "reusable/ButtonBaseBlank"
import styled from "styled-components"
import { StyledRow, StyledSvgIcon, TypographyRtl } from "theme/shared"

const StyledButtonBase = styled(ButtonBaseBlank)`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  /* if not last child add border bottom */
  padding: 16px;
  cursor: pointer;
  a:not(:last-child) & {
    border-bottom: 1px solid ${(p) => p.theme.colors.borderGrey};
  }
`

const StyledText = styled(TypographyRtl).attrs({ variant: "body2" })<{
  $page: string
}>`
  font-weight: 400;
  ${(p) =>
    p?.$page === STEPS_EN.summary &&
    `
  font-size: 16px;
  font-family: ${Font.OENaPro};
  `}
`

type PurchaseToolsRowProps = ButtonBaseProps & {
  text: string
  iconName: string
  page?: string
}

const PurchaseToolsRow = ({
  iconName,
  text,
  page,
  ...props
}: PurchaseToolsRowProps) => {
  return (
    <StyledButtonBase {...props}>
      <StyledRow $gap="10px">
        <StyledSvgIcon
          src={`/icons/${iconName}.svg`}
          alt={text}
          $w={24}
          $h={24}
          role="presentation"
          aria-hidden="true"
        />
        <StyledText $page={page || ""}>{text}</StyledText>
      </StyledRow>
      <StyledSvgIcon src={`/icons/grayArrow.svg`} alt={text} $w={18} $h={18} />
    </StyledButtonBase>
  )
}

export default PurchaseToolsRow
